import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatDate, formatEUR } from "@/lib/api";
import { PageHeader, EmptyState, MetricCard } from "@/components/ui-kit";
import { Wallet, AlertTriangle } from "lucide-react";

export default function Recouvrement() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/dossiers", { params: { facture_statut: "en_retard" } }).then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  const total_du = items.reduce((s, d) => s + (d.commission_montant || 0), 0);

  return (
    <div className="p-8" data-testid="recouvrement-page">
      <PageHeader title="Recouvrement" subtitle="Factures en retard" />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <MetricCard label="Factures en retard" value={items.length} icon={AlertTriangle} tone="danger" testid="rec-metric-count" />
        <MetricCard label="Montant total dû" value={formatEUR(total_du)} icon={Wallet} tone="danger" testid="rec-metric-total" />
        <MetricCard label="Action requise" value="Relance" icon={AlertTriangle} tone="warning" testid="rec-metric-action" />
      </div>

      <div className="bg-white rounded-sm border border-slate-200 overflow-hidden">
        {loading ? <div className="p-10 text-center text-slate-500">Chargement…</div> :
          items.length === 0 ? <EmptyState icon={Wallet} title="Aucune facture en retard" description="Bravo, toutes les factures sont à jour." /> :
          <table className="w-full text-sm">
            <thead className="bg-slate-50"><tr>
              <th className="text-left px-4 py-3 font-semibold uppercase text-xs">N° facture</th>
              <th className="text-left px-4 py-3 font-semibold uppercase text-xs">Client</th>
              <th className="text-left px-4 py-3 font-semibold uppercase text-xs">Promoteur</th>
              <th className="text-left px-4 py-3 font-semibold uppercase text-xs">Date envoi</th>
              <th className="text-right px-4 py-3 font-semibold uppercase text-xs">Commission due</th>
            </tr></thead>
            <tbody>{items.map((d) => (
              <tr key={d.id} className="border-t border-slate-100 hover:bg-slate-50">
                <td className="px-4 py-3 font-mono text-xs">{d.facture_numero || "—"}</td>
                <td className="px-4 py-3"><Link to={`/dossiers/${d.id}`} className="font-semibold text-[#111111] hover:text-[#B8873A]">{d.client_prenom} {d.client_nom}</Link></td>
                <td className="px-4 py-3">{d.promoteur || "—"}</td>
                <td className="px-4 py-3">{formatDate(d.facture_date_envoi)}</td>
                <td className="px-4 py-3 text-right font-bold text-red-700">{formatEUR(d.commission_montant)}</td>
              </tr>))}
            </tbody>
          </table>}
      </div>
    </div>
  );
}
